//reference https://github.com/sindresorhus/p-is-promise/blob/main/index.js

const isObject = (value: any) =>
  value !== null && (typeof value === 'object' || typeof value === 'function');

export default function pIsPromise(value: any) {
  return (
    value instanceof Promise ||
    (isObject(value) &&
      typeof value.then === 'function' &&
      typeof value.catch === 'function')
  );
}
